// interface for Authorization Service
//

// user role element
import {Observable} from "rxjs";

// user role record
export type ROLE =
{
	id: string; // role id
	name: string  // role description
}

export interface IAuthorizeService
{
	getEmailObs(): Observable<string>; // return user email

	getUserNameObs(): Observable<string>;  // return username

	getRolesObs(): Observable<ROLE[]>; // return all roles

	getUserRoleObs(): Observable<string>; // return user role id

	// apply changes on user role
	setUserRoleObs(roleId: string): Observable<boolean>; // return 'true' if set was successful

	// handler invoked after a user role has changed (e.g. for cleaning 'storage' stuff, window reload, etc.)
	changeUserRoleHandler(): void;
}